import { render, staticRenderFns } from "./ShortSummaryControl.vue?vue&type=template&id=28773224&scoped=true"
import script from "./ShortSummaryControl.vue?vue&type=script&lang=js"
export * from "./ShortSummaryControl.vue?vue&type=script&lang=js"
import style0 from "./ShortSummaryControl.vue?vue&type=style&index=0&id=28773224&prod&lang=scss&scoped=true"
import style1 from "./ShortSummaryControl.vue?vue&type=style&index=1&id=28773224&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28773224",
  null
  
)

export default component.exports